import { api } from './index.ts';

const FILE_NAMES_BY_LANGUAGE: Record<string, string> = {
  javascript: 'main.js',
  typescript: 'main.ts',
  go: 'main.go',
};

export const executeCode = (code: string, language: string) => {
  return api.post('/execute-code', {
    language: language,
    version: '*',
    files: [
      {
        name: FILE_NAMES_BY_LANGUAGE[language],
        content: code,
      },
    ],
  });
};
